import React, {useEffect, useState} from 'react'
import { uploadFileResource} from "../../service/http-service";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'

export const ProfileDocumentForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()
    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [showError, setShowError] = useState(false)
    const [backError, setBackError] = useState('Прикачениот документ ја надминува дозволената големина од 5 MB')

    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
        setIsFilePicked(true);
        setShowError(false)
    };

    const handleSubmission = () => {
        let formData = new FormData();
        formData.append("file", selectedFile);
        setSelectedFile(null)

        if(entityTemp.id){
            formData.append("entityId", entityTemp.id);
        }else{
            formData.append("entityId", 0);
        }

        formData.append("candidateId", entityTemp.candidate.id);

        for (let key of formData.entries()) {
            console.log(key[0] + ', ' + key[1]);
        }
        uploadFileResource('candidates/add_candidate_document', formData).then((data) => {
            console.log(data.data)
            setShowError(false)
            setAddEntity(false)
            setEntityTemp({candidate: entityTemp.candidate})
            setUpdateEntity(!updateEntity)
        }).catch((exception) => {
            console.log(exception)
            setShowError(true);
        })
    };

    useEffect (() => {
        setEntity(entityTemp)
    }, []);


    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <form id="newDocForm" className="col-lg-10 offset-lg-1">
                            <input type="file" className="file input-form w-100 my-3"
                                   formtype="multipart/form-data"
                                   onChange={(e) => changeHandler(e)}/>
                            {showError && <b className="blue">{backError}</b>}
                            <div className="d-flex justify-content-between">
                                <div
                                    className="btn-form"
                                    onClick={()=>
                                    {setAddEntity(false)
                                        setEntityTemp({candidate: entity.candidate})
                                    }}
                                >Затвори</div>
                                <div
                                    type='button'
                                    className="btn-form"
                                    onClick={(e) => handleSubmission()}
                                >Зачувај</div>
                            </div>


                        </form>
                    </>
            )
                }
        </div>
    )
}